import { SUBSCRIPTION_PROVIDER } from 'lib/constants/subscriptionProvider';

const { appName } = SUBSCRIPTION_PROVIDER;

interface SellingPlanNode {
  id: string;
}

interface SellingPlanConnection {
  nodes: SellingPlanNode[];
}

interface SellingPlanGroupNode {
  appName: string | null;
  sellingPlans: SellingPlanConnection;
}

export interface SellingPlanGroups {
  nodes: (SellingPlanGroupNode | null)[];
}

export const getSubProviderSellingPlanIds = (
  groups: SellingPlanGroups | null,
): string[] => {
  if (!groups?.nodes) {
    return [];
  }

  return groups.nodes.reduce<string[]>((acc, group) => {
    if (group?.appName === appName) {
      const planInfo = group.sellingPlans.nodes
        .filter((node): node is SellingPlanNode => node !== null)
        .map((node) => node.id);
      acc.push(...planInfo);
    }
    return acc;
  }, []);
};
